// HERO_PHOTO_URL — the photograph behind the home hero and the sign-in panel.
//
// Supplied by the operator 2026-08-26 to replace the branded CSS gradient that
// stood in both places: a booking site whose front page shows no room asks the
// guest to trust it on nothing.
//
// It is already a Cloudflare Image Transformation URL over one of our own
// apartment photos (`format=auto` so browsers that take AVIF/WebP get them,
// `onerror=redirect` so a transformation failure serves the original rather
// than nothing).
//
// Hardcoded on purpose, and only for now: choosing the front-page photograph
// belongs to the operator, and the field that will hold it is site_config
// (OH-154). One constant, so the swap is one line rather than a search.
export const HERO_PHOTO_URL =
  'https://assets.ollio.place/cdn-cgi/image/width=1920,format=auto,quality=80,onerror=redirect/apartments/019f3e2c-5aa7-761a-ab77-156c50028356/019f3e2e-12de-7ce2-bbc3-7bc1f9d3a472.jpg';
